import { Popover as MuiPopover, styled } from "@mui/material";
import { ReactNode, useContext } from "react";
import { EditorCtx } from "../../wysiwyg/EditorCtx";
import { iframe } from "../../helpers/environment";

interface Props {
  anchorEl: HTMLButtonElement | null;
  children: ReactNode;
  desktop: boolean;
  onClose: () => void;
}

export const popupElevation = 3;
const StyledPopper = styled(MuiPopover)<{
  canvasWidth?: number;
  canvasHeight?: number;
}>(({ theme }) => ({
  width: "100%",
  maxWidth: "60rem",
  maxHeight: "60rem",
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  "& .MuiPaper-root": {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    display: "none",
    "& .MuiPaper-root": {
      width: "initial",
    },
    "& .MuiBackdrop-root": {
      backgroundColor: "transparent",
    },
  },
}));

const StyledPopperDesktop = styled(StyledPopper)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("md")]: {
    marginTop: theme.spacing(1),
    display: "block",
  },
}));

const ContentContainer = styled("div")<{
  isEditor?: boolean;
}>(({ isEditor }) => ({
  padding: "0.5rem",
  minWidth: isEditor ? "20rem" : 0,
  maxWidth: isEditor ? "60rem" : "initial",
}));

function Popover({ anchorEl, desktop, onClose, children }: Props) {
  const { isEditor } = useContext(EditorCtx);

  const props = {
    open: true,
    onClose,
    anchorEl,
    ...(iframe
      ? {
          disableScrollLock: true,
          disableEnforceFocus: true,
          disableAutoFocus: true,
          disableRestoreFocus: true,
        }
      : {}),
  };

  return desktop ? (
    <StyledPopperDesktop
      {...props}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      hideBackdrop={false}
    >
      <ContentContainer isEditor={isEditor}>{children}</ContentContainer>
    </StyledPopperDesktop>
  ) : (
    <StyledPopper
      {...props}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        horizontal: "center",
        vertical: "center",
      }}
      hideBackdrop={false}
    >
      <ContentContainer isEditor={isEditor}>{children}</ContentContainer>
    </StyledPopper>
  );
}

export default Popover;
